<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';

import type { DropdownItem } from '@/models/dropdown-item';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  items: {
    type: Array<DropdownItem>,
    required: true,
  },
});

const emit = defineEmits<{
  'item-selected': [item: any];
  'update:visible': [visible: boolean];
}>();

const dropdownRef = ref<HTMLElement | null>(null);

function handleAction<T extends DropdownItem>(item: T) {
  emit('item-selected', item);
}

onClickOutside(dropdownRef, () => {
  emit('update:visible', false);
});
</script>

<template>
  <ul v-if="props.visible" ref="dropdownRef" role="menu">
    <li v-for="(item, index) in items" :key="index" class="dropdown-item" role="menuitem" @click="handleAction(item)">
      {{ item.label }}
    </li>
  </ul>
</template>

<style scoped lang="scss">
ul {
  padding: 0;
  width: 100%;
  z-index: 1000;
  overflow: hidden;
  border-radius: 12px;
  list-style-type: none;
  background-color: white;
  backdrop-filter: blur(80px);
  box-shadow: 0px 8px 64px rgba(0, 0, 0, 0.1);
}

li {
  cursor: pointer;
  padding: 11px 16px;
  width: 100%;
  white-space: nowrap;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  font-family: 'On Diatype Standard';
}

li:not(:last-child) {
  border-bottom: 0.5px solid var(--shade-3);
}

li:hover {
  background-color: var(--shade-2);
}
</style>
